"use strict";
/* tslint:disable */
var TBaseLineType = (function () {
    return {
        buildRowWrapperContent: function (selection, mode, context, lineType, selectionType) {
            var __html = '';
            if (!selection.Initialized) {
                __html += TSlipShared.createLoadingBox(selection);
            }
            else if (!selection.Valid && !selection.BranchID) {
                __html += TSlipShared.createNoDataBox(selection);
            }
            else {
                __html += TBuildLine[lineType](selection, selectionType, mode, context);
            }
            __html += TSlipShared.createOverlayMessage(mode, selection, context);
            if (mode.IsSelectionRemoveButton) {
                __html += TSlipShared.createRemoveButton(selection.ViewKey);
            }
            return __html;
        },
        createEachwayBox: {
            defaultLine: function (selection, mode, context) {
                if (!BetSlipUtil.hasEachWay(selection, mode, context)) {
                    return '';
                }
                var checked = Selections.isEachwayIncluded(mode, selection, context) ? "checked" : "";
                return `
                <div class="betSlipEachWay" data-uat="bet-slip-each-way">
                    <label for="chkEachWay_${selection.ViewKey}">
                        <strong class="betSlipEachWay__title" data-uat="bet-slip-each-way-label">
                            <small>${Selections.getEachWayString(selection)}</small>
                        </strong>
                        <input id="chkEachWay_${selection.ViewKey}" class="chck" type="checkbox" onchange="UniSlipBlock.updateEachWay(${selection.ViewKey})" ${checked} data-uat="bet-slip-each-way-checkbox" />
                        <span class="icon i-24 i-o-controls-checkmark"></span>
                    </label>
                </div> 
            `;
            },
            UKLine: function (selection, mode, context) {
                if (!BetSlipUtil.hasEachWay(selection, mode, context)) {
                    return '';
                }
                var checked = selection.EachWaySingleIncluded ? "checked" : "";
                return `
                <div class="betSlipEachWay" data-uat="bet-slip-each-way">
                    <label for="chkEachWay_${selection.ViewKey}" data-uat="bet-slip-each-way-label">
                        <input id="chkEachWay_${selection.ViewKey}" class="chck" type="checkbox" onchange="UniSlipBlock.updateEachWay(${selection.ViewKey},${UKSlipModeSubModes.Single})" ${checked} data-uat="bet-slip-each-way-checkbox" />
                        <span class="icon i-24 i-o-controls-checkmark"></span>
                        ${this.buildUKEachWayTitle(selection)}
                    </label>
                </div>
            `;
            },
            buildUKEachWayTitle: function (selection) {
                return this[BetSlipTemplateConroller.getUKEachWayTitleTemplate(BetSlip.TemplateType)](selection);
            },
            buildRegularUKEWTitle: function (selection) {
                return `<strong data-uat="bet-slip-each-way-label">${$string('General').EachWayTag}</strong>`;
            },
            buildResponsiveUKEWTitle: function (selection) {
                return `<strong class="betSlipEachWay__title" data-uat="bet-slip-each-way-label"><small>${Selections.getEachWayString(selection)}</small></strong>`;
            }
        }
    };
}());
window.TBaseLineType = TBaseLineType;
//# sourceMappingURL=TBaseLineType.js.map